<section hlmCard>
  <details class="group">
    <summary
      class="hover:bg-muted/50 flex cursor-pointer items-center justify-between px-4 py-3 transition-colors select-none">
      <span class="text-base font-medium">
        Details & Verlauf
        @if (redemptions().length > 0) {
          <span hlmMuted class="text-sm font-normal">· {{ redemptions().length }} Einlösungen</span>
        }
      </span>
      <ng-icon name="lucideChevronDown" class="transition-transform group-open:rotate-180" />
    </summary>

    <div class="space-y-4 border-t px-4 py-4">
      <dl class="grid grid-cols-2 gap-4">
        <div>
          <dt hlmMuted class="text-xs">Kaufdatum</dt>
          <dd class="text-sm font-medium">{{ formatDate(createdAt()) }}</dd>
        </div>
        <div>
          <dt hlmMuted class="text-xs">Gültig bis</dt>
          <dd class="text-sm font-medium" [class.text-destructive]="isExpired()">
            {{ expiresAt() ? formatDate(expiresAt()!) : 'Unbegrenzt' }}
            @if (isExpired()) {
              (abgelaufen)
            }
          </dd>
        </div>
      </dl>

      @if (sorted().length > 0) {
        <div class="space-y-2">
          <h3 hlmSmall>Einlöse-Verlauf</h3>
          <div hlmTableContainer>
            <table hlmTable>
              <thead hlmTHead>
                <tr hlmTr>
                  <th hlmTh>Datum</th>
                  @if (showLocation()) {
                    <th hlmTh>Standort</th>
                  }
                  <th hlmTh class="text-right">Betrag</th>
                </tr>
              </thead>
              <tbody hlmTBody>
                @for (redemption of sorted(); track redemption.id) {
                  <tr hlmTr>
                    <td hlmTd class="whitespace-nowrap">
                      {{ formatDateTime(redemption.redeemed_at) }}
                    </td>
                    @if (showLocation()) {
                      <td hlmTd>{{ redemption.redeeming_company_name || '–' }}</td>
                    }
                    <td hlmTd class="text-right font-medium tabular-nums">
                      {{ money(redemption.amount) }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      } @else {
        <p hlmMuted class="text-sm">Dieser Gutschein wurde noch nicht eingelöst.</p>
      }
    </div>
  </details>
</section>
